<template>
  <div>
    <div class="reappro reappro--mobile" v-if="$store.getters['auth/isRole']('ROLE_TECHNICIAN') == true">
      <ReapproHeader :list="true" class="reappro__header--list"></ReapproHeader>
      <div class="content-area content-area--mobile">
        <a class="left-sidebar__link left-sidebar__link--current active" @click.prevent="displayCurrent = !displayCurrent;">
          <span><strong>Mes réappros en cours</strong> ({{ currentItems.length }})</span>
          <img v-if="displayCurrent" src="/static/img/pictos/moins.svg">
          <img v-else src="/static/img/pictos/plus.svg">
        </a>
        <div class="reappro__list"  v-show="displayCurrent == 1">
          <Reappro v-for="item in currentItems" :item="item" :key="item.id" class="reappro--mobile"></Reappro>
        </div>
        <a class="left-sidebar__link left-sidebar__link--old" @click.prevent="displayOld = !displayOld;">
          <span><strong>Mes anciens réappros</strong> ({{ oldItems.length }})</span>
          <img v-if="displayOld" src="/static/img/pictos/moins.svg">
          <img v-else src="/static/img/pictos/plus.svg">
        </a>
        <div class="reappro__list"  v-show="displayOld == 1">
          <Reappro v-for="item in oldItems" :item="item" :key="item.id" class="reappro--mobile" :repass="true"></Reappro>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import ReapproHeader from "@/components/Reappro/ReapproHeader";
import ProductFamilyList from "@/components/ProductFamily/ProductFamilyList";
import Reappro from "@/components/Reappro/Reappro";

export default {
  name: "ReapproList",
  data() {
    return {
      displayCurrent: 1,
      displayOld: 0,
    };
  },
  created(){
    this.$store.dispatch('showLoader');
  },
  computed: {
    items: function() {
      let items = this.$store.getters["order/getMyReappros"];
      if (items) {
        return items;
      }
    },
    currentItems: function() { return this.items.filter(function(i) { return i.status != 5 && i.status != 9 }) },
    oldItems: function() { return this.items.filter(function(i) { return i.status == 5 || i.status == 9 }) },
  },
  mounted() {
    this.$store.dispatch("order/getMyReappros").then(() => {
      this.$store.dispatch('hideLoader');
    });
  },
  methods: {

  },
  components: {
    ReapproHeader,
    ProductFamilyList,
    Reappro
  }
};
</script>


<style lang="scss" scoped>
  @import "~@/assets/scss/_colors.scss";

  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: white;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: $grisclair;
    border-radius: 20px;
    height: 5px;
  }

  .reappro{ display: flex;
    &--mobile{ flex-direction: column;
      .left-sidebar__link{ margin-bottom: 0; margin-top: 0;
        &:last-of-type{ margin-top: 0; }
        &.active{
          &:after{ content: none; }
        }
      }
    }
  }
  .left-sidebar{
    &__header{ background-color: $color3; display: flex; height: 300px; flex-direction: column; align-items: center; justify-content: center;
      img{ width: 100px; margin-left: 35px; }
      span{ color: white; font-family: 'ClanFFBlack'; font-size: 20px; margin-top: 25px; text-transform: uppercase; }
    }
    &__link{ height: 75px; display: flex; color: white; padding: 0 20px; flex-direction: row; align-items: center; justify-content: space-between; position: relative;
      &.active{
        &:after{ content: ""; position: absolute; right: -10px; width: 0; height: 0; border-style: solid; border-width: 10px 0 10px 10px;  }
      }
      &--current{ background-color: $color2;
        &.active{
          &:after{ border-color: transparent transparent transparent $color2; }
        }
      }
      &--old{ background-color: $color1;
        &.active{
          &:after{ border-color: transparent transparent transparent $color1; }
        }
      }
      img{ width: 20px; }
      span{ color: white; font-size: 14px;
        strong{ font-family: 'ClanProBold'; }
      }
    }
  }
  .content-area{ width: calc(100% - 300px); padding: 0 7%; margin-top: 80px;
    h1{ font-family: 'ClanFFBlack'; color: $color2; font-size: 25px; margin-bottom: 50px; position: relative; padding-bottom: 30px;
      &:before{ content: ""; display: block; width: 60px; height: 8px; background-color: $color2; border-radius: 4px; position: absolute; bottom: 0; }
    }
    .reappro__list{ overflow: auto; height: 500px; padding-right: 20px; }
    &--mobile{ width: 100%; padding: 0; margin-top: 0;
      .reappro__list{ height: auto; padding: 20px 0 0 0; }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Reappro/ReapproList.vue